import { getDocumentFileDownloadUrl } from '../api/documents';

interface DocumentFileActionInput {
  fileId: string;
  objectId: string;
}

// openDocumentFileToView resolves a signed URL and opens the document in a new browser tab.
export async function openDocumentFileToView({
  fileId,
  objectId,
}: DocumentFileActionInput): Promise<void> {
  const downloadUrl = await getDocumentFileDownloadUrl(fileId, objectId, false);
  window.open(downloadUrl, '_blank', 'noopener,noreferrer');
}

// downloadDocumentFile resolves a signed URL and triggers a browser download.
export async function downloadDocumentFile({
  fileId,
  objectId,
}: DocumentFileActionInput): Promise<void> {
  const downloadUrl = await getDocumentFileDownloadUrl(fileId, objectId, true);
  triggerDownload(downloadUrl, "");
}

function triggerDownload(downloadUrl: string, fileName: string) {
  const anchor = document.createElement('a');
  anchor.href = downloadUrl;
  anchor.download = fileName;
  anchor.rel = 'noopener noreferrer';
  anchor.style.display = 'none';
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
}
